import React, { useContext, useEffect, useState, useRef } from "react";
import axios from "axios";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import Leftbar from "../components/Leftbar/Leftbar";
import Button from "../components/Button/Button";
import "../pagesStyling/Chat.css";
import { AuthContext } from "../components/AuthContext/AuthContext";
import { useSelectedCollections } from "../components/SelectedCollectionsContext/SelectedCollectionsContext";
import { API_BASE_URL } from "../apiConfig";

function Chat() {
  const { token } = useContext(AuthContext) || {};
  const isChatHistoryFetched = useRef(false);
  const [isChatStarted, setIsChatStarted] = useState(false);
  const [chats, setChats] = useState<
    { id: string; chatTopic: string; chatText: string; creationDate: Date }[]
  >([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const { selectedCollections } = useSelectedCollections();

  useEffect(() => {
    const fetchChatHistory = async () => {
      if (!token || isChatHistoryFetched.current) return;

      isChatHistoryFetched.current = true;

      try {
        const response = await axios.get(`${API_BASE_URL}/chat/history`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const data = response.data;
        const formattedChats = (data.previous_chats || []).map((chat: any) => {
          const topic = chat.first_prompt || "Untitled Chat";
          const truncatedTopic =
            topic.length > 15 ? topic.substring(0, 15) + "..." : topic;
          return {
            id: chat.uuid,
            chatTopic: truncatedTopic,
            chatText: truncatedTopic || "",
            creationDate: new Date(chat.created_at),
          };
        });

        setChats(formattedChats);
      } catch (error) {
        console.error("Error fetching chat history:", error);
      }
    };

    fetchChatHistory();
  }, [token]);

  useEffect(() => {
    if (id) setIsChatStarted(true);
    else setIsChatStarted(false);
  }, [id]);

  const startNewChat = async () => {
    try {
      const collections = selectedCollections.map(
        (collection) => collection.uuid
      );
      const requestBody = { collections };

      const response = await axios.post(
        `${API_BASE_URL}/chat/new`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      const newChatId = response.data.chat_uuid;
      navigate(`/chat/${newChatId}`, { state: { isNewChat: true } });
      setIsChatStarted(true);
    } catch (error) {
      console.error("Error starting new chat:", error);
    }
  };

  return (
    <div className="chat-page-container">
      <Leftbar
        title="Chat"
        hasButton={true}
        hasChat={true}
        text="New chat"
        onButtonClick={startNewChat}
        chats={chats}
      />
      <div
        className={`chat-content ${
          !isChatStarted ? "chat-content-landing" : "chat-content-selected"
        }`}
      >
        <div className="chat-interface-container">
          {!isChatStarted ? (
            <div className="welcome-container">
              <h2>
                Chat with DCA to find the information you are looking for in
                your documents
              </h2>
              <p className="welcome-text">
                Start a new chat or jump back into a previous chat.
              </p>
              <Button onClick={startNewChat} text={"+ Start new chat"} />
            </div>
          ) : (
            <Outlet context={{ setChats, chats }} key={id} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Chat;
